export default function VideoAlbum() {
  return <>VideoAlbum</>;
}
